export default "https://ssr-releases-cdn.paperlesspost.com/_next/static/video/CardsPoster-5d8bd32e79c57df1ef15eb6282d63898.jpg";